import { render, staticRenderFns } from "./DraftListHeader.vue?vue&type=template&id=38fbe56b&scoped=true&"
import script from "./DraftListHeader.vue?vue&type=script&lang=js&"
export * from "./DraftListHeader.vue?vue&type=script&lang=js&"
import style0 from "./DraftListHeader.vue?vue&type=style&index=0&id=38fbe56b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbe56b",
  null
  
)

export default component.exports